import * as Sentry from '@sentry/react'
import React from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
Sentry.init({
  dsn: 'https://c12135ffb41f47f5a38cd78fca61dc58@o1412931.ingest.sentry.io/4505240628822016',
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    //  performance
    // If you're using react router, use the integration for your react router version instead.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    //  performance
    //  session-replay
    Sentry.replayIntegration({
      networkDetailAllowUrls: [
        /^https:\/\/dbfm\.iskra\.cat/,
        /^https:\/\/backfm\.iskra\.cat/,
        /^https:\/\/content\.firamediterrania\.cat/,
        /^https:\/\/api\.firamediterrania\.cat/,
      ],
      networkCaptureBodies: true,
      // Keep headers minimal; defaults include Content-Type, Content-Length, Accept
      // networkRequestHeaders: ['...'],
      // networkResponseHeaders: ['...'],
      beforeAddRecordingEvent(event) {
        // Keep only failed requests (status >= 400), e.g., 412
        if (
          event.type === 5 /* RRWeb: incremental snapshot */ &&
          event.data?.tag === 'performanceSpan' &&
          event.data?.payload?.op === 'resource.fetch' &&
          typeof event.data?.payload?.statusCode === 'number'
        ) {
          return event.data.payload.statusCode > 401 ? event : null
        }
        // Pass through non-network events
        return event
      },
    }),
    //  session-replay
    //  user-feedback
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: 'system',
      autoInject: false,
    }),
    Sentry.httpClientIntegration({
      failedRequestStatusCodes: [412, 422, 500, 502, 503, 504],
      sendDefaultPii: true,
    }),
    //  user-feedback
  ],
  //  logs
  // Enable logs to be sent to Sentry
  enableLogs: true,
  //  logs
  //  performance
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
  //  performance
  //  session-replay
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  //  session-replay
})
